export default {
      id: "ic-soc-twitter-usage",
      viewBox: "0 0 26 26",
      url: "../dist/images/" + "sprite.svg#ic-soc-twitter-usage",
      toString: function () {
        return this.url;
      }
    }